import { SortResult } from "../../components/rank-sort/types";
import { RESPONSE_TYPE } from "../../const/vote";
import { IQuestionState } from "../../domain/ballot-state";
import { ApiIQuestion } from "../../domain/election";
import { QuestionValidationResult, VoteFieldValidation } from "../types";

export type PreferenceVote = { [candidate_id: string]: SortResult<string> };

export class CHECK_LIST {
    static TYPE = RESPONSE_TYPE.CHECK_LIST;
    static DATA_VERSION = "1.0.0";
    static INITIAL_VALUE: PreferenceVote = {
    }

    static normalize = (questionState?: IQuestionState): PreferenceVote => {
        if (!questionState) {
            return CHECK_LIST.INITIAL_VALUE;
        }
        const { response_type, data_version, value } = questionState;
        if (response_type !== CHECK_LIST.TYPE) {
            return CHECK_LIST.INITIAL_VALUE
        }
        if (data_version !== CHECK_LIST.DATA_VERSION) {
            return CHECK_LIST.INITIAL_VALUE;
        }
        if (!value) {
            return CHECK_LIST.INITIAL_VALUE
        }
        return value;
    };

    static validate = (ballot: ApiIQuestion, vote: PreferenceVote): QuestionValidationResult => {
        const { required, voting_config } = ballot;
        if (required) {
            const selected = Object.values(vote).filter(c => c.index !== null)
            if (selected.length === 0) {
                return { valid: false, empty: true }
            }
        }
        if (!voting_config) {
            return { valid: true, empty: false }
        }
        const min_select = voting_config.min_select ? Number(voting_config.min_select) : null;
        const max_select = voting_config.max_select ? Number(voting_config.max_select) : null;

        const reasons: Array<VoteFieldValidation> = [];
        const totalVotes = Object.values(vote).length;
        const candidates = totalVotes + 1;
        const count = Object.values(vote).filter(v => v.index !== null).length
        if (max_select && count > max_select) {
            reasons.push({
                reason: "too_many_candidates",
                meta: { expected: max_select, found: candidates },
            });
        }
        if (min_select && (count === null || count < min_select)) {
            reasons.push({ reason: "not_enough_candidates", meta: { expected: min_select, found: candidates } });
        }
        return {
            valid: reasons.length === 0,
            empty: false,
            reasons,
        };
    };

    static prepare = (ballot: ApiIQuestion, vote: PreferenceVote): PreferenceVote => {
        const votes = Object.values(vote).filter(v => v.index !== null).sort(sortPreferences);
        for (let i = 0; i < votes.length; i++) {
            vote[votes[i].id].index = i + 1;
        }
        return vote;
    };
}



export const sortPreferences = (a: SortResult, b: SortResult) => {
    if (a.index === null)
        return 1;
    if (b.index === null)
        return -1;
    return a.index > b.index ? 1 : -1
}
